module.exports = __webpack_public_path__ + "img/review-2.d237808d.png";